// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__35J87","header":"PatientQuestionnaire_header__nRWTm","info":"PatientQuestionnaire_info__1Yvft"};